export default __webpack_public_path__ + "src/images/packages/eco-karoo-lodge/61854525c173f9dc088b8fb748648bdc-3.png";